module.exports = __webpack_public_path__ + "media/icons/chevron-small-d0b03358.svg";